// extracted by mini-css-extract-plugin
export default {"container":"Chat_container__cS7v2","content":"Chat_content__Rsbi+","list":"Chat_list__Fvd-p"};